/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/


export enum StepEnum {
    "color" = "color",
    "color_collapsible" = "color_collapsible",
    "version" = "version",
    "version_collapsible" = "version_collapsible",
    "color_version" = "color_version",
    "print_option" = "print_option",
    "print_option_per_position" = "print_option_per_position",
    "print_option_collapsible" = "print_option_collapsible",
    "production_speed" = "production_speed",
    "quantity" = "quantity",
    "quantity_per_color" = "quantity_per_color",
    "quantity_per_size" = "quantity_per_size",
    "quantity_per_size_per_color" = "quantity_per_size_per_color",
    "quantity_per_variant" = "quantity_per_variant",
    "quantity_collapsible" = "quantity_collapsible",
    "quantity_per_color_collapsible" = "quantity_per_color_collapsible",
    "quantity_per_size_collapsible" = "quantity_per_size_collapsible",
    "quantity_per_size_per_color_collapsible" = "quantity_per_size_per_color_collapsible"
}

export type Step = StepEnum;